import { render, staticRenderFns } from "./withdrawalRules.vue?vue&type=template&id=f0720f5e&scoped=true&"
import script from "./withdrawalRules.vue?vue&type=script&lang=js&"
export * from "./withdrawalRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0720f5e",
  null
  
)

component.options.__file = "withdrawalRules.vue"
export default component.exports